import { Box, CircularProgress, Stack, Typography } from "@mui/material";

import StockCountListCard from "./StockCountListCard";

export default function StockCountsList({
  rows = [],
  loading = false,
  disabled = false,
  cancellingStockCountId = null,
  onView,
  onCancel,
  emptyMessage = "Todavía no hay conteos de stock solicitados.",
}) {
  if (loading && rows.length === 0) {
    return (
      <Stack
        spacing={1.5}
        sx={{
          flex: 1,
          minHeight: 220,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={28} />
        <Typography sx={{ color: "neutral.700", fontWeight: 650 }}>
          Cargando conteos de stock...
        </Typography>
      </Stack>
    );
  }

  if (!loading && rows.length === 0) {
    return (
      <Box
        sx={{
          flex: 1,
          minHeight: 220,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          px: 2,
          textAlign: "center",
        }}
      >
        <Typography sx={{ color: "neutral.700", fontWeight: 650 }}>
          {emptyMessage}
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={0.75}>
      {rows.map((stockCount) => (
        <StockCountListCard
          key={stockCount.id}
          stockCount={stockCount}
          disabled={disabled || loading}
          cancelling={cancellingStockCountId === stockCount.id}
          onView={onView}
          onCancel={onCancel}
        />
      ))}
    </Stack>
  );
}
